import React, {useEffect} from "react";
import DashboardLayout from "../../layouts/Dashboard";
import RequestLockCRUDTable from "../../components/CRUD/Tables/RequestLockCRUDTable";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { REQUEST_LOCK_CREATE_ROUTE } from "../../routes";
import { REQUEST_LOCK_EDIT_ROUTE } from "../../routes";
import { REQUEST_LOCK_DETAILS_ROUTE } from "../../routes";
import { requestLockCRUD } from "../../http";
import useReload from "../../hooks/useReload";

const RequestLockList = () => {
    const location = useLocation();

    const { push } = useHistory();

    const { reload, reloadValue } = useReload();

    const handleDelete = async (id) => {
        await requestLockCRUD.delete(id);
        await reload();
    }

    return (
        <DashboardLayout>
            <RequestLockCRUDTable
                onClickCreateButton={() => push(REQUEST_LOCK_CREATE_ROUTE)}
                onRowClick={(record, rowIndex) => push(REQUEST_LOCK_EDIT_ROUTE(record.id), { record })}
                onClickDetailsButton={(id) => push(REQUEST_LOCK_DETAILS_ROUTE(id), { id })}
                onClickDeleteButton={(id) => handleDelete(id)}
                reloadValue={reloadValue}
            />
        </DashboardLayout>
    )
};

export default RequestLockList;
